export const getTranslationQueryKey = (culture: string) => `/api/proxy/content/translations/${culture}`;
